import  { Children } from "react";
import { TableRow, TableHead, TableCell, Typography } from "@mui/material";
import { memo } from "utils/memo";
import { get } from "lodash";

const TableHeader = ({ columns = [] , padding }:{columns:any[], padding : any}) => {
  return (
    <TableHead>
      <TableRow>
        {Children.toArray(
          columns.map((column: any) => {
            return (
              <TableCell
                key={column.label}
                align={get(column, "align", "")}
                sx={{
                  border: "none",
                  textTransform:"capitalize",                 
                   padding:padding,
                }}
              >
                <Typography
                  variant="body1"
                  fontSize={14}
                  noWrap
                  fontWeight={600}
                >
                  {column.label}
                </Typography>
              </TableCell>
            );
          })
        )}
      </TableRow>
    </TableHead>
  );
};

export default memo(TableHeader);
